module.exports = __webpack_public_path__ + "img/contact.24297c95.jpg";